import { toast } from "react-toastify";

// `exposedToast` é uma constante de módulo, então não há nada para memoizar:
// o useRef que existia aqui só servia para ler .current em fase de render.
export default function useToast() {
  return exposedToast;
}

const params = {
  // Na v11 o objeto toast.POSITION foi removido; a posição virou string.
  position: "top-center",
  autoClose: 2000,
};

const exposedToast = {
  toastSuccess: (text, extra = {}) =>
    toast.success(text, { ...params, ...extra }),
  toastError: (text, extra = {}) => toast.error(text, { ...params, ...extra }),
};
